<!-- Accordian  bg-grey-->
<div class="card mb15 scrollbar app ">
<div class="ctm-tab custom-card card-accord">
    <ngb-accordion #a="ngbAccordion" activeIds="first">
        <ngb-panel id="first">
            <ng-template ngbPanelHeader class="custom-header ctm">
                <div class="d-flex align-items-center">
                    <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center" aria-label="Center Align">
                        lblWOConfirmation
                        <ng-container *ngIf="!a.activeIds.includes('first')"><em
                                class="fas fa-angle-down fa-lg ml-auto"></em>
                        </ng-container>
                        <ng-container *ngIf="a.activeIds.includes('first')"><em
                                class="fas fa-angle-up fa-lg ml-auto"></em>
                        </ng-container>
                    </button>
                </div>
            </ng-template>
            <ng-template ngbPanelContent>
                <div class="">
                    <div class="table-responsive">
                        <table class="tablest1 table-hover">
                            <thead>
                                <tr>
                                    <th scope="col" style="width: 50px"></th>
                                    <th scope="col" translate>lblDemand</th>
                                    <th scope="col" translate>lblJob</th>
                                    <th scope="col" translate style="min-width: 220px;">
                                        
                                        lblDescription
                                        
                                    </th>
                                    <th  scope="col" translate>lblSalesPart</th>
                                    <th scope="col" style="width: 120px" translate>lblQty<span>/</span><span
                                            translate>lblTime</span></th>
                                    <th class="text-right" scope="col" translate>lblPrice</th>
                                    <th style="min-width: 120px" class="text-right no-nowrap" scope="col" translate>
                                        
                                        lblFixedPrice
                                    
                                    </th>
                                    <th style="width: 100px" class="text-center no-nowrap" class="text-center" scope="col" translate>lblPartInStock
                                    </th>
                                    <th scope="col" style="min-width: 100px" class="text-center no-nowrap" translate>lblCanBeDoneNow</th>
                                    <th style="width: 100px" class="text-center no-nowrap" scope="col" translate>
                                        lblCustomerReply</th>
                                    <th style="width: 100px" class="text-center no-nowrap" scope="col" translate>
                                        lblMechanicApproved</th>
                                    <th style="width: 100px" class="text-center no-nowrap" scope="col" translate>
                                        lblAdminApproved</th>
                                    <th style="width: 100px" class="text-center no-nowrap" scope="col" translate>
                                        lblCDSSApproved</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="additionalWorkDetailsModel?.length>0; else load_else">
                                    <ng-container *ngFor="let check of additionalWorkDetailsModel; let i=index"
                                        class="mb-3">
                                        <tr [ngClass]="{'bg-info': check.expanded}" >
                                            <td>
                                                <a class="btn btn-ico" (click)="check.expanded = !check.expanded">
                                                    <em class="fas fa-chevron-right fa-lg" [ngClass]="{'fa-chevron-up': check.expanded}"></em>
                                                </a>
                                            </td>

                                            <td>{{ check.demand }}</td>
                                            <td></td>
                                            <td>{{check.description}}</td>
                                            <td></td>
                                            <td></td>
                                            <td class="text-right">{{check.price | number:'1.2-2'}}</td>
                                            <td class="text-right">{{check.fixedPrice | number:'1.2-2'}}</td>
                                            <td></td>
                                            <td class="text-center"><input type="checkbox" id="DemandCan{{i}}"
                                                    [(ngModel)]="check.canBeDoneNow"
                                                    [disabled]="!check.isEnable || !check.isDemandEnable || check.isAdminApproved === -1 || check.isCDSSApproved === -1 || check.isCustomerApporved === -1 || isApprove"
                                                    (ngModelChange)="emitCanBeDoneNowData($event,check)" />
                                            </td>
                                            <td class="text-center">
                                                <ng-container
                                                    *ngIf="check.isCustomerApporved !== -1; else additionalworkc_else">
                                                    <input type="checkbox" id="DemandCustomer{{i}}"
                                                        [(ngModel)]="check.isCustomerApporved" disabled
                                                        (ngModelChange)="emitCustomerApprovedData($event,check)" />
                                                </ng-container>
                                                <ng-template #additionalworkc_else>
                                                    <em class="fas fa-times fa-lg" style="cursor: pointer"
                                                        (click)="OpenUpdateDemandConfirmation(check)"></em>
                                                </ng-template>

                                            </td>
                                            <td class="text-center">
                                                <ng-container
                                                    *ngIf="check.isMechanicApproved !== -1; else additionalworkm_else">
                                                    <input type="checkbox" id="DemandMechanic{{i}}"
                                                        [(ngModel)]="check.isMechanicApproved" disabled />
                                                </ng-container>
                                                <ng-template #additionalworkm_else>
                                                    <em class="fas fa-times fa-lg" style="cursor: pointer"
                                                        (click)="OpenUpdateDemandConfirmation(check)"></em>
                                                </ng-template>
                                            </td>
                                            <td class="text-center">
                                                <ng-container
                                                    *ngIf="check.isAdminApproved !== -1; else additionalwork_else">
                                                    <input type="checkbox" id="DemandAdmin{{i}}"
                                                        [(ngModel)]="check.isAdminApproved"
                                                        [disabled]="isReception || !check.isEnable || !check.isDemandEnable"
                                                        (ngModelChange)="emitAdminApprovedData($event,check)" />
                                                </ng-container>
                                                <ng-template #additionalwork_else>
                                                    <em class="fas fa-times fa-lg" style="cursor: pointer"
                                                        (click)="OpenUpdateDemandConfirmation(check)"></em>
                                                </ng-template>

                                            </td>

                                            <td translate class="text-center">
                                                <ng-container
                                                    *ngIf="check.isCDSSApproved !== -1; else additionalworkr_else">
                                                    <input type="checkbox" id="DemandCdss{{i}}"
                                                        [(ngModel)]="check.isCDSSApproved"
                                                        [disabled]="isAdmin || !check.isEnable || !check.isDemandEnable"
                                                        (ngModelChange)="emitCDSSApprovedData($event,check)" />

                                                </ng-container>
                                                <ng-template #additionalworkr_else>
                                                    <em class="fas fa-times fa-lg" style="cursor: pointer"
                                                        (click)="OpenUpdateDemandConfirmation(check)"></em>
                                                </ng-template>

                                            </td>
                                        </tr>
                                        <ng-container *ngIf="check.expanded">
                                            <tr class="table-active checkListItems">
                                               <td colspan="14" class=" " class="p-2 pl47">
                                                    <table class="tablest1">
                                                        <tr>
                                                            
                                                            <th scope="col" style="width:100px" translate>lblDemand</th>
                                                            <th scope="col" style="width:80px" translate>lblJob</th>
                                                            <th scope="col" translate>lblDescription</th>
                                                            <th  scope="col" translate>lblSalesPart</th>
                                                            <th scope="col" style="width:120px" translate>lblQty<span>/</span><span
                                                                    translate>lblTime</span></th>
                                                            <th class="text-right" scope="col" translate>lblPrice</th>
                                                            <th style="width:120px" class="text-center no-nowrap" scope="col" translate>lblFixedPrice
                                                            </th>
                                                            <th style="width:100px" class="text-center no-nowrap" class="text-center" scope="col" translate>lblPartInStock
                                                            </th>
                                                            <th scope="col" style="width:100px" class="text-center no-nowrap" translate>lblCanBeDoneNow</th>
                                                            <th style="width:100px" class="text-center no-nowrap" scope="col" translate>
                                                                lblCustomerReply</th>
                                                            <th style="width:100px" class="text-center no-nowrap" scope="col" translate>
                                                                lblMechanicApproved</th>
                                                            <th style="width:100px" class="text-center no-nowrap" scope="col" translate>
                                                                lblAdminApproved</th>
                                                            <th style="width:100px" class="text-center no-nowrap" scope="col" translate>
                                                                lblCDSSApproved</th>
                                                        </tr>
                                                        <tr *ngFor="let item of check.jobDetails; let i=index" class="checkListItems">
                                                            
                                                            <td>{{ item.demandNo }}</td>
                                                            <td>
                                                                <ng-container *ngIf="item.isJob; else isJob_else">
                                                                    {{ item.jobNo }}
                                                                </ng-container>
                                                                <ng-template #isJob_else>
                                                                </ng-template>
                                                            </td>
                                                            <td>{{ item.description}}</td>
                                                            <td>{{ item.partNumber}}</td>
                                                            <td>{{item.time}}</td>
                                                            <td class="text-right">{{item.price | number:'1.2-2'}}</td>
                                                            <td>{{ item.fixedPrice | number:'1.2-2'}}</td>
                                                            <td>{{ item.quantity }}</td>
                                                            <td class="text-center">
                                                                <input type="checkbox" id="DemandCanitem{{i}}"
                                                                    [(ngModel)]="item.canBeDoneNow"
                                                                    [disabled]="!item.isEnable || !check.isDemandEnable|| item.isAdminApproved === -1 || item.isCDSSApproved === -1 || item.isCustomerApporved === -1 || isApprove" 
                                                                    (ngModelChange)="CanBeDoneNowData($event,check,check.jobDetails[i].isJob)" />
            
                                                            </td>
                                                            <td class="text-center">
                                                                <ng-container
                                                                    *ngIf="item.isCustomerApporved !== -1; else additionalworkcc_else">
            
                                                                    <input type="checkbox" id="DemandCustomeritem{{i}}"
                                                                        [(ngModel)]="item.isCustomerApporved"
                                                                        disabled="!item.isEnable || !check.isDemandEnable" />
            
                                                                </ng-container>
                                                                <ng-template #additionalworkcc_else><em
                                                                        class="fas fa-times fa-lg"></em>
                                                                </ng-template>
            
                                                            </td>
                                                            <td class="text-center">
                                                                <ng-container
                                                                    *ngIf="item.isMechanicApproved !== -1; else additionalworkmd_else">
                                                                    <input type="checkbox" id="DemandMechanicitem{{i}}"
                                                                        [(ngModel)]="item.isMechanicApproved" disabled />
                                                                </ng-container>
                                                                <ng-template #additionalworkmd_else><em
                                                                        class="fas fa-times fa-lg"></em>
                                                                </ng-template>
                                                            </td>
                                                            <td translate class="text-center">
                                                                <ng-container
                                                                    *ngIf="item.isAdminApproved !== -1; else additionalwork_else">
                                                                    <input type="checkbox" id="DemandAdminitem{{i}}"
                                                                        [(ngModel)]="item.isAdminApproved"
                                                                        [disabled]="isReception || !item.isEnable || !check.isDemandEnable"
                                                                        (ngModelChange)="AdminNowData($event,check,check.jobDetails[i].isJob)" />
                                                                </ng-container>
                                                                <ng-template #additionalwork_else><em class="fas fa-times fa-lg"></em>
                                                                </ng-template>
            
                                                            </td>
            
                                                            <td translate class="text-center">
                                                                <ng-container
                                                                    *ngIf="item.isCDSSApproved !== -1; else additionalworkr_else">
                                                                    <input type="checkbox" id="DemandCdssitem{{i}}"
                                                                        [(ngModel)]="item.isCDSSApproved"
                                                                        [disabled]="isAdmin || !item.isEnable || !check.isDemandEnable"
                                                                        (ngModelChange)="CDSSNowData($event,check,check.jobDetails[i].isJob)" />
                                                                </ng-container>
                                                                <ng-template #additionalworkr_else><em
                                                                        class="fas fa-times fa-lg"></em>
                                                                </ng-template>
            
                                                            </td>
                                                        </tr>
                                                    </table>
                                               </td> 
                                            </tr>

                                            

                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                                <ng-template #load_else>
                                    <tr>
                                        <td colspan="14" class="no-record" translate>lblNoRecordsFound</td>
                                    </tr>
                                </ng-template>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-footer px-0 text-right">
                        <button class="btn btn-primary mr-sm-2  " (click)="ApproveOrReject(false,true,false)"
                            translate [disabled]="!isCanBeDoneNow || isApprove || !editAppointmentService.isEdit" aria-label="Center Align" >lblCustomersApproval</button>
                        <button class="btn btn-primary mr-sm-2  " (click)="OpenSendNotificationModel(false,true)" translate
                            [disabled]="!isCanBeDoneNow || !isApprove || !editAppointmentService.isEdit" aria-label="Center Align">lblApproveAndSendNotification</button>
                        <button class="btn btn-primary mr-sm-2  " (click)="ApproveOrReject(false,false,false)"
                            [disabled]="!isCanBeDoneNow || !isApprove || !editAppointmentService.isEdit" translate aria-label="Center Align">lblApproveWithoutNotify</button>
                        <button class="btn btn-primary mr-sm-2  " (click)="OpenSendNotificationModel(true,true)" translate 
                            [disabled]="!isCanBeDoneNow || !isApprove || !editAppointmentService.isEdit" aria-label="Center Align">lblRejectAndNotify</button>
                        <button class="btn btn-primary mr-sm-3  " (click)="ApproveOrReject(true,false,false)"
                            [disabled]="!isCanBeDoneNow || !isApprove || !editAppointmentService.isEdit" translate aria-label="Center Align">lblRejectWithoutNotify</button>
                    </div>

                </div>
            </ng-template>
        </ngb-panel>


    </ngb-accordion>
</div>
</div>

<ng-template #updateDemandConfirmContent let-modal>
    <div class="modal-header border-b">
        <h4 class="modal-title title" translate>lblUpdateDemandConfirmation</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(null)">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body margin-td">
        <p class="modal-desc py-4 text-break" translate>lblAreYouSureWantToApproveThisDemand</p>
    </div>
    <div class="modal-footer">
        <div class="d-flex flex-sm-row flex-column justify-content-end">
            <button type="button" class="btn btn-primary mr-sm-2 mb-2 mb-sm-0" aria-label="Center Align" translate
                (click)="modal.dismiss(true)">lblApproveAndSendNotification</button>
            <button type="button" class="btn btn-primary mr-sm-2 mb-2 mb-sm-0" aria-label="Center Align" translate
                (click)="modal.dismiss(false)">lblApproveWithoutNotify</button>
            <button type="button" class="btn btn-secondary" aria-label="Center Align" translate
                (click)="modal.dismiss(null)">lblCancel</button>
        </div>
    </div>
</ng-template>

<ng-template #customerListContent let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblCustomers</h4>
        <button type="button" #closeModal id="modelButton" class="close" aria-label="Center Align"
            (click)="modal.dismiss(false)">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="card pad15">
            <div class="row" *ngIf="customerList.length>0">
                    <table>
                        <thead>
                            <tr>
                                <th translate>lblSelect</th>
                                <th translate>lblName</th>
                                <th translate>lblContactMobile</th>
                                <th translate>lblCustomerNo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let customer of customerList; let i = index">
                                <td>
                                    <input type="radio" name="customerRadio" [id]="'customerRadio' + i"
                                    (change)="SendSMSCustomer(customer,i)">
                                </td>
                                <td>
                                    <label [for]="'customerRadio' + i" translate class="ml-2">
                                        {{customer.customerName}}
                                    </label>
                                </td>
                                <td>
                                    <label [for]="'customerRadio' + i" translate class="ml-2">
                                        {{customer.customerMobileNumber}}
                                    </label>
                                </td>
                                <td>
                                    <label [for]="'customerRadio' + i" translate class="ml-2">
                                        {{customer.customerNo}}
                                    </label>
                                </td>
                            </tr>
                        </tbody>
                    </table>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="d-flex flex-sm-row flex-column justify-content-end">
            <button type="submit" class="btn btn-primary mr-sm-2" translate (click)="modal.dismiss(false);UpdateAdditionalWorkDetails(true,false,false)"
                aria-label="Center Align" [disabled]="customerRadio == -1">lblSendNotification</button>
            <button (click)="modal.dismiss(false)" class="btn btn-secondary" aria-label="Center Align"
                translate>lblCancel</button>
        </div>
    </div>
</ng-template>